/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';

export type ListenersIpAddressPortsType = {
  [key: string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    (clonedTemplate.private as FormTemplateSection).fields.PRIVATEIP.readOnly = true;
    (clonedTemplate.private as FormTemplateSection).fields.PRIVATEPORT.readOnly = true;
    (clonedTemplate.public as FormTemplateSection).fields.PUBLICIP.readOnly = true;
    (clonedTemplate.public as FormTemplateSection).fields.PUBLICPORT.readOnly = true;
  }

  if (
    (mode === 'edit') &&
    (clonedTemplate.private as FormTemplateSection)?.metadata?.layout?.rows != null
  ) {
    (clonedTemplate.private as FormTemplateSection).fields.PRIVATEIP.readOnly = true;
    (clonedTemplate.private as FormTemplateSection).fields.PRIVATEPORT.readOnly = true;
  }

  return clonedTemplate;
}
